import { appointmentReferenceService } from './AppointmentReference.service';

class OrderViewModelFactory {
    build(serverResponse, headerInformation) {
        const appointmentData = this._buildAppointmentData(serverResponse);
        return {
            orders: this._buildDisplayableOrderList(appointmentData, headerInformation),
            headers: headerInformation,
            error: serverResponse.error,
            appointmentErrors: serverResponse.appointmentErrors
        };
    }

    _buildAppointmentData(orderList) {
        return orderList.appointments.map((appointment, index) => {
            return {
                appointment,
                tableData: orderList.tableData[index]
            };
        });
    }

    _buildDisplayableOrderList(appointments, headers) {
        return appointments.map((data) => {
            const appointment = data.appointment;

            const viewModel = {
                orderId: appointment.orderId,
                type: data.tableData["Stop Type"],
                confirmed: appointment.confirmed,
                stopAction: appointment.stopAction,

                references: appointmentReferenceService.buildReferenceList(appointment.orderReferenceToValues),
                additionalWorklist: {},

                selectedAppointmentSuggestionIndex: 0,
                appointmentSuggestionsList: appointment.appointmentSuggestions,
                showAppointmentReferenceNumber: appointment.appointmentReferenceRequired,
                showPreloadedEquipmentDecal: appointment.preloadedEquipmentNumberRequired,
                appointmentReferenceNumber: '',
                preloadedEquipmentDecalId: '',

                lineOfBusiness: appointment.lineOfBusiness,
                reschedule: appointment.reschedule,

                originalOrder: data
            };

            headers
                .filter(h => h.isAdditionalWorklistColumn)
                .forEach(h => {
                    viewModel.additionalWorklist[h.objectKey] = appointment[h.objectKey];
                });

            return viewModel;
        }).sort((a, b) => {
            return a.orderId - b.orderId;
        });
    }
}

export const orderViewModelFactory = new OrderViewModelFactory();
